<template>
  <div class="company_list">
    <Header></Header>
    <div class="row"  style="display: block; height: 2500px;">
      <div class="container">
        <loading :active.sync="visible" :can-cancel="false"></loading>
        <CompanyListHeader></CompanyListHeader>
        <div class="content-inner">
          <CompanyListFilter></CompanyListFilter>
          <div class="list-content-section">
            <CompanyListSort></CompanyListSort>
            <CompanyItem v-for="company in company_list" :key="company.id" :company="company"></CompanyItem>
            <paginate
              style="margin-top:20px"
              v-model="page"
              :page-count="content_length"
              :click-handler="get_company_list_page"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'page-item'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import EventBus from "@/EventBus.js";
import Header from "@/SharedComponents/Header.vue";
import CompanyListHeader from "@/SPA/CompanyList/Components/CompanyListHeader.vue";
import CompanyListFilter from "@/SPA/CompanyList/Components/CompanyListFilter.vue";
import CompanyListSort from "@/SPA/CompanyList/Components/CompanyListSort.vue";
import CompanyItem from "@/SPA/CompanyList/Components/CompanyItem.vue";
import Footer from "@/SharedComponents/Footer.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    Header,
    CompanyListHeader,
    CompanyListFilter,
    CompanyListSort,
    CompanyItem,
    Footer,
    Loading
  },
  data() {
    return {
      company_list: [],
      origin_company_list: [],
      content_length: 1,
      page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      visible: true,
      search_text: "",
      sort: "",
      first_lock:0,
      data: {
        selected_detail_service_filters: [],
        selected_service_filters: [],
        selected_local_filters: [],
        selected_cert_filters: "",
        is_premium_view: true
      }
    };
  },
  methods: {   
    get_company_list_page(){
      this.company_list = this.origin_company_list.slice( (this.page-1) * 8 , (this.page) * 8 )

    },
    get_company_list() {
      console.log("여기서 호출")
      if(this.first_lock > 2 ){
      this.visible = true;
      this.$http
        .post(
          `app/get_company_list?sort=${this.sort}&text=${this.search_text}`,
          this.data
        )
        .then(res => {
            this.origin_company_list = res.data.result;
            this.visible = false;
            this.content_length = res.data.company_length;
            this.page=1
            this.company_list = this.origin_company_list.slice( (this.page-1) * 8 , (this.page) * 8 )

        });
      }
        this.first_lock = this.first_lock +1 
    }
  },
  mounted() {
    $(".fixing").remove();
    this.visible = true;
    // 초기데이터 받아오기
    this.get_company_list();
     // 이벤트 버스 리스닝
    EventBus.$on("company_filter", res => {
      console.log("컴퍼니 필터 호출")
      this.data = res;
      this.get_company_list();
    });
    EventBus.$on("favorite_company_list", res => {
      this.get_company_list();
    });
    EventBus.$on("change_filter", res => {
      console.log("필터 체인지")
      this.sort = res;
      this.get_company_list();
    });
    EventBus.$on("sesarch_text", str => {
      this.search_text = str;
      this.get_company_list();
    });
  },
  beforeDestroy(){
    EventBus.$off("sesarch_text" );
    EventBus.$off("company_filter" );
    EventBus.$off("favorite_company_list" );
    EventBus.$off("change_filter" );
  }
};
</script>

<style scoped lang="scss">
.list-content-section {
  width: 905px;
  margin-left: 205px;
}
</style>



// WEBPACK FOOTER //
// src/SPA/CompanyList/CompanyList.vue